import { useQuery } from "@tanstack/react-query";
import queryKeys from "../../constants/queryKeys";
import timesheetService from "../../services/timesheetService";

const useVisitSummary = () =>
    useQuery({
        queryKey: [queryKeys.visitSummary],
        queryFn: () => timesheetService.fetchVisitSummary(),
    });

export default useVisitSummary;
